module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topbar"
    }
  }, [_c('div', {
    staticClass: "topbar"
  }, [_c('button', {
    on: {
      "click": _vm.exit
    }
  }, [_vm._v("Se déconnecter")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'myMatchs'
      }
    }
  }, [_c('button', [_vm._v("Mon compte")])]), _vm._v(" "), (_vm.currentUser) ? _c('h3', {
    attrs: {
      "id": "username"
    }
  }, [_vm._v(_vm._s(_vm.currentUser.username))]) : _c('h3', [_vm._v("Username not found")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41f7d6b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topbar.vue
// module id = 739
// module chunks = 0